/**
 * BLOCK - PRODUCT RECOMMANDATIONS - LISTENERS
 */

// On page load
window.addEventListener('DOMContentLoaded', loadProductRecommendations);

/**
 * BLOCK - PRODUCT RECOMMANDATIONS - GENERAL
 */

// Displays product recommendations
function loadProductRecommendations() {
  document.querySelectorAll('.products-recommendations').forEach((element) => {
    element.dataset.productsSource != 'recently-viewed' ? loadComplementaryOrRelatedProducts(element) : loadRecentlyViewedProducts(element);
  });
}

// Loads products recommendations where source is 'complementary' or 'related'
function loadComplementaryOrRelatedProducts(productsRecommendation) {
  var url = productsRecommendation.dataset.productsSourceUrl;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      var container = document.createElement('div');
      
      container.innerHTML = text;
  
      if (productsRecommendation.classList.contains('carousel-wrapper')) {
        var recommendations = container.querySelector('.carousel-wrapper.products-recommendations');
      } else {
        var recommendations = container.querySelector('.grid.products-recommendations');
      }
  
      if (recommendations !== null) {
        productsRecommendation.parentNode.innerHTML = recommendations.parentNode.innerHTML;
        setupEventListenersAfterFetchingProductsRecommendations();
        startCarousels(false);
      }   
    })
    .catch((event) => {
      console.error(event);
    });
}

// Creates the event listeners needed after fetch
function setupEventListenersAfterFetchingProductsRecommendations() {
  setupEventListenersForProductsItems();
}

// Loads products recommendations where source is 'recently-viewed'
function loadRecentlyViewedProducts(productsRecommendation) {
  productsRecommendation.classList.contains('carousel-wrapper') ? loadRecentlyViewedProductsInCarousel(productsRecommendation) : loadRecentlyViewedProductsInGrid(productsRecommendation);  
  if (productsRecommendation.querySelectorAll('.item-product') === null) productsRecommendation.closest('.shopify-block').remove(); // If no products are shown, we remove the block
}

// Loads products recommendations where source is 'recently-viewed' - Carousel
function loadRecentlyViewedProductsInCarousel(productsRecommendation) {
  var productsRecentlyViewed = sessionStorage.getItem('recently_viewed');

  if (productsRecentlyViewed == null) productsRecentlyViewed = '';
  
  productsRecommendation.querySelectorAll('.carousel-cell').forEach((element) => {
    var productToCheckHandle = element.querySelector('.item-product').dataset.itemHandle;

    if (productsRecentlyViewed.indexOf(productToCheckHandle) == -1) {
      var style = element.querySelector('.carousel-cell--wrapper').previousElementSibling;

      if (style !== null) element.nextElementSibling.querySelector('.carousel-cell--inner').prepend(style);      
      element.remove();
    }
  });

  productsRecommendation.classList.add('loaded');
  if (isSliderInitialized(productsRecommendation)) productsRecommendation.closest('.carousel').swiper.update();
}

// Loads products recommendations where source is 'recently-viewed' - Grid
function loadRecentlyViewedProductsInGrid(productsRecommendation) {
  var productsRecentlyViewed = sessionStorage.getItem('recently_viewed');

  if (productsRecentlyViewed === null) productsRecentlyViewed = '';
  
  productsRecommendation.querySelectorAll('.grid__cell').forEach((element) => {
    var productToCheckHandle = element.querySelector('.item-product').dataset.itemHandle;

    if (productsRecentlyViewed.indexOf(productToCheckHandle) == -1) element.remove();
  });

  productsRecommendation.classList.add('loaded');
}